<template>
    <div class="card flex-grow-1" :class="{editable}">
        <div class="card-body d-flex flex-column justify-content-center" @click.prevent.stop="showEditModal()">
            <div class="description"
                 :class="{'empty-block': !lesson_plan_excerpt.length}">

                <markdown-text v-if="expanded" :content="lesson_plan" />
                <markdown-text v-else :content="lesson_plan_excerpt" />

                <div v-if="is_excerpted" class="mt-2">
                    <a href="#"
                       class="more text-light font-weight-bold"
                       @click.prevent.stop="toggleExpanded()">
                        Read more.
                    </a>
                </div>

            </div>
<!--            <div class="download" v-if="lesson_plan.file">-->
<!--                <a :href="lesson_plan.file.url"-->
<!--                   target="_blank"-->
<!--                   class="btn btn-light">-->
<!--                    Download-->
<!--                </a>-->
<!--            </div>-->
        </div>

        <modal :id="utils.randomId({prefix: 'edit-lesson-plan'})"
               size="lg"
               v-if="edit_modal.enabled"
               :show="edit_modal.enabled"
               @close="closeEditModal()">


            <template #title>
                Update Teacher Guide
            </template>

            <div class="form-group">
                <label for="lesson-plan">Teacher Guide</label>
                <textarea id="lesson-plan"
                          class="form-control"
                          rows="10"
                          placeholder="Write some text here."
                          v-model="edit_modal.text"></textarea>
            </div>

            <template #footer>
                <button type="button"
                        @click="closeEditModal()"
                        class="btn btn-warning">Cancel</button>
                <button type="button"
                        @click="saveEditModal()"
                        class="btn btn-success ml-auto">Save</button>
            </template>

        </modal>

        <modal :id="utils.randomId({prefix: 'preview-lesson-plan'})"
               size="lg"
               v-if="preview_modal.enabled"
               :show="preview_modal.enabled"
               @close="closePreviewModal()">


            <template #title>
                Complete Teacher Guide
            </template>

            <markdown-text :content="lesson_plan" />

            <template #footer>
                <button type="button"
                        @click="closePreviewModal()"
                        class="btn btn-success ml-auto">Done</button>
            </template>

        </modal>

    </div>
</template>

<script>
import utils from "@/mixins/utils";
import Modal from "@/Components/Common/Modal";
import MarkdownText from "@/Components/Common/MarkdownText";
import {mapActions} from "vuex";

export default {
    name: "LessonPlan",
    components: {Modal, MarkdownText},
    mixins: [utils],

    props: {
        path: Object,
        stage: '',
        editable: false,
    },

    data(){
        return {

            expanded: false,

            edit_modal: {
                enabled: false,
                text: '',
            },

            preview_modal: {
                enabled: false,
            }
        }
    },


    computed: {
        fragment_key(){
            return `stage_${this.stage}_teacher_guide_text`;
        },

        lesson_plan: {
            get(){
                const str = typeof this.path?.fragments[ this.fragment_key ] !== 'undefined' ? this.path?.fragments[ this.fragment_key ] : '';
                return str ? str : '';
            },
            set(val){
                return this.path.fragments[ this.fragment_key ] = val;
            }
        },

        lesson_plan_excerpt(){
            if( !this.lesson_plan ) return '';
            return this.utils.excerpt( this.lesson_plan, 600 );
        },

        is_excerpted(){
            return this.lesson_plan.length > this.lesson_plan_excerpt.length;
        },

    },


    methods: {

        ...mapActions('repositories', {
            updateRepo: 'updateRepository',
        }),

        toggleExpanded(){
            this.expanded = !this.expanded;
        },

        showPreviewModal(){
            this.preview_modal.enabled = true;
        },

        closePreviewModal(){
            this.preview_modal.enabled = false;
        },

        showEditModal(){

            if( !this.editable ) return;

            this.edit_modal.enabled = true;
            this.edit_modal.text = this.lesson_plan;
        },

        closeEditModal(){
            this.edit_modal.enabled = false;
            this.edit_modal.text = '';
        },

        saveEditModal(){

            this.lesson_plan = this.edit_modal.text;

            const fragments = {};
            fragments[ this.fragment_key ] = this.lesson_plan;

            this.updateRepo({scope: this.path.scope, fragments});

            this.closeEditModal();
        }
    }

}
</script>

<style lang="scss" scoped>

.card{
    background-color: $success;
    color: white;
}

.description{
    font-size: 1rem;
    // margin-bottom: 1rem;
}

.editable{
    .card-body{
        cursor: text;

        &:hover{
            > * {
                background: rgba(black, 0.05);
            }
        }
    }

    .empty-block{
        &:after{
            display: block;
            font-style: italic;
            content: 'No teacher guide have been added. Click to add.';
            text-align: center;
        }
    }


}

.empty-block{
    &:after{
        font-style: italic;
        content: 'Guide not presented.';
    }
}

.more{
    margin-left: 1.3rem;
}

</style>
